import { useEffect } from 'react';

const spriiWidgetSrc = 'https://widget.cdn.sprii.shop/widget-202158343149190.js';
const spriiWidgetId = 'sprii-widget-script';

export default function SpriiWidgetLoader() {
    useEffect(() => {
        const existingById = document.getElementById(spriiWidgetId) as HTMLScriptElement | null;
        if (existingById) return;

        const script = document.createElement('script');
        script.id = spriiWidgetId;
        script.src = spriiWidgetSrc;
        script.type = 'module';
        script.crossOrigin = 'anonymous';
        script.async = true;
        document.head.appendChild(script);
    }, []);

    return (
        <>
            <div
                className="sprii-shows-gallery"
                data-sprii-mode="shows"
                data-sprii-statuses="live"
                data-sprii-autoplay="minimized"
            />

            <div className="sprii-shows-gallery" data-sprii-mode="shows" data-sprii-statuses="planned" />

            <div
                className="sprii-shows-gallery"
                data-sprii-mode="shows"
                data-sprii-statuses="vod"
                data-sprii-page-size="8"
            />
        </>
    );
}
